import { useSharedLinkInitialData } from '@hook/sharedLinkData';
import { useSharedLinkId, useSharedLinkResource } from '@hook/useSharedLinkResource';
import SharedLinkState from '@module/sharedLinkState';
import { getPackageOrderByOrderId } from '@storeData/order';
import { redirectToHome } from '@util/routerService';
import { useSelector } from 'react-redux';
import PackageInvoiceModal from './packageInvoiceModal';

function PackageInvoicePage() {
    const orderId = useSharedLinkId();
    const { configData } = useSelector((state: any) => state.store.storeData);
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords
    const { data: orderData, state, retry } = useSharedLinkResource({
        id: orderId,
        initialData: useSharedLinkInitialData('package', orderId),
        fetcher: getPackageOrderByOrderId
    });

    return (
        <div className="invoice-wrapper">
            {state === 'ready' && <PackageInvoiceModal
                orderData={orderData}
                handleClose={() => { }} />}
            <SharedLinkState
                state={state}
                onRetry={retry}
                onSecondaryAction={Boolean(configData?.storeConfig?.basicConfig?.catalogue) ? redirectToHome : undefined}
                loadingText="Loading your package invoice..."
                notFoundText="The package invoice you are looking for is not available."
                errorText="We couldn't load your package invoice. Please check your connection and try again."
                secondaryActionText="Explore more services"
            />
            {state === 'ready' && Boolean(configData?.storeConfig?.basicConfig?.catalogue) && <div className="footer-btn-wrap">
                <button className='primary-btn' onClick={redirectToHome}>{languageData["Explore More Services & Products"] ? languageData["Explore More Services & Products"] : "Explore More Services & Products"}</button>
            </div>}
        </div>
    )
}

export default PackageInvoicePage